import * as Types from '../../constants/actionTypes';
import AuthAxios from '../../models/Axios';
import { LOCAL_URL } from '../../helper/constant';
import Auth from "../../models/Auth";
// import { Loading } from 'react-loading-ui';

// export const LoadingWithText = () => {
//     Loading({
//         title: "Loading...",
//         text: "",
//         progress: false,
//         progressedClose: false,
//         theme: "light",
//     });
// }

/* Set New Portal Error */
export const SET_PORTAL_REDUCER_ERROR = (message) => (dispatch) => {
    return dispatch({ type: Types.PORTAL_ERROR, portalError: message })
}

export const GET_PORTAL_LOGO = () => (dispatch) => {
    // let img = new Image()
    // img.src = portalLogoUrl()
    dispatch({ type: Types.SET_PORTAL_LOGO, selectedPortalLogo: true, portalLogoName: 'defaultLogo' })
}

export const GET_CURRENT_PORTAL= () => async (dispatch) => {
    
    try {
        const response = await AuthAxios.axios.get(`${LOCAL_URL}/portal/getPortal/${Auth.portalId}`);
        if (response.data) {
            await dispatch({
                type: Types.CURRENT_PORTAL,
                data: response.data.data,
            })
            return response?.data?.data;
        }
    } catch (error) {
        return error
    }
}

export const GET_ALL_PORTAL_LANGUAGES = (payload) => async (dispatch) => {
    try {
        const URL = `${LOCAL_URL}/portalcultures/getPortalCultureList`
        const response = await AuthAxios.axios.get(URL, { params: payload })
        await dispatch({
            type: Types.CULTURES_DETAIL_SUCCESS,
            payload: response.data && response.data.data,
        })
        return response?.data?.data
    } catch (error) {
        dispatch({ type: Types.CULTURES_DETAIL_ERROR, payload: error })
    }
}